import parallel from 'async/parallel'
riot.tag2('delivery-condition-regions-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Регион доставки</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="name" value="{item.name}" type="text">\n        </div>\n        <div class="form-group">\n          <label class="control-label">Страна</label>\n          <autocomplete name="idCountryTo" value-field="name" data="{countries}" onchange="{changeCountry}" min-symbols="2" value="{item.idCountryTo}">{item.name}</autocomplete>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Регион</label>\n          <autocomplete name="idRegionTo" value-field="name" data="{getRegions(tags.idCountryTo.value)}" __disabled="{tags.region.data.length == 0 &amp;&amp; tags.country.value == undefined}" onchange="{changeRegion}" min-symbols="2" value="{item.idRegionTo}">{item.name}</autocomplete>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Город</label>\n          <autocomplete name="idCityTo" value-field="name" data="{cities}" __disabled="{tags.country.value == undefined}" min-symbols="2" value="{item.idCityTo}">{item.name}</autocomplete>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Срок доставки (1, 1-2)</label>\n          <input class="form-control" name="period" value="{item.period}" type="text">\n        </div>\n        <div class="form-group">\n          <label class="control-label">Цена</label>\n          <input class="form-control" name="price" value="{item.price}" min="0" type="{\'number\'}">\n        </div>\n        <div class="form-group">\n          <label class="control-label">Макс. объем</label>\n          <div class="input-group">\n            <input class="form-control" name="maxVolume" value="{item.maxVolume}" min="0" type="{\'number\'}">\n            <div class="input-group-addon">м<sup>3</sup></div>\n          </div>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Макс. вес</label>\n          <div class="input-group">\n            <input class="form-control" name="maxWeight" value="{item.maxWeight}" min="0" type="{\'number\'}">\n            <div class="input-group-addon">гр.</div>\n          </div>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Адрес склада/примечание</label>\n          <textarea class="form-control" rows="5" name="note" style="min-width: 100%; max-width: 100%;" value="{item.note}"></textarea>\n        </div>\n        <div class="form-group">\n          <div class="checkbox-inline">\n            <label>\n              <input type="checkbox" name="isActive" __checked="{item.isActive}">Активная\n            </label>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.on('mount', function () {
    var modal = self.tags['bs-modal'];

    modal.item = opts.item || {
        isActive: true
    };
    modal.mixin('change');
    modal.mixin('validation');

    modal.getRegions = function (id) {
        if (modal.regions instanceof Array && id !== undefined) return modal.regions.filter(function (item) {
            return item.idCountry == id;
        });else return [];
    };

    modal.changeCountry = function (e) {
        modal.getCities(this.idCountryTo.value, this.idRegionTo.value);
    };

    modal.changeRegion = function (e) {
        modal.getCities(this.idCountryTo.value, this.idRegionTo.value);
    };

    modal.getCities = function (country, region) {
        return API.request({
            object: 'GeoCity',
            method: 'Fetch',
            data: { idCountry: country, idRegion: region },
            success: function success(response) {
                modal.cities = response.items;
                modal.update();
            }
        });
    };

    parallel([function (callback) {
        API.request({
            object: 'GeoCountry',
            method: 'Fetch',
            success: function success(response) {
                modal.countries = response.items;
                callback(null, 'Countries');
            },
            error: function error(response) {
                callback('error', null);
            }
        });
    }, function (callback) {
        API.request({
            object: 'GeoRegion',
            method: 'Fetch',
            success: function success(response) {
                modal.regions = response.items;
                callback(null, 'Regions');
            },
            error: function error(response) {
                callback('error', null);
            }
        });
    }], function (err, res) {
        if (modal.item.idCityTo != null) {
            var ids = [modal.item.idCityTo];

            API.request({
                object: 'GeoCity',
                method: 'Fetch',
                data: { ids: ids },
                success: function success(response) {
                    modal.item.idCountryTo = response.items[0].idCountry;
                    modal.item.idRegionTo = response.items[0].idRegion;

                    modal.countries.forEach(function (item) {
                        if (item.id == modal.item.idCountryTo) modal.tags.idCountryTo.filterValue = item.name;
                    });

                    modal.regions.forEach(function (item) {
                        if (item.id == modal.item.idRegionTo) modal.tags.idRegionTo.filterValue = item.name;
                    });

                    modal.tags.idCityTo.filterValue = response.items[0].name;

                    modal.loader = false;
                    modal.update();
                }
            });
        } else {
            modal.loader = false;
            modal.update();
        }
    });
});
});


// WEBPACK FOOTER //
// ./pages/delivery/delivery-condition-regions-modal.tag